import * as Yup from "yup";

export default function () {
    return Yup.string().nullable()
        .test('is-postcode', "Please enter valid postcode", (val) => {
            if(val === null || val === undefined) return true;
            const regExp = /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/gi;
            return regExp.test(val);
        })
}
